import { render, staticRenderFns } from "./ColaboradorForm.vue?vue&type=template&id=c97d67e8&scoped=true"
import script from "./ColaboradorForm.vue?vue&type=script&lang=js"
export * from "./ColaboradorForm.vue?vue&type=script&lang=js"
import style0 from "./ColaboradorForm.vue?vue&type=style&index=0&id=c97d67e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97d67e8",
  null
  
)

export default component.exports